// extracted by mini-css-extract-plugin
export var dateLabel = "_3x-0";
export var dateLabelError = "_3x-1";
export var fullWidth = "_3x-2";
export var smaller = "_3x-3";